import { Box, Grid, Image } from '@chakra-ui/react';
import { InputField } from '../../../inputs/InputField/inputField';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { TwoColumn } from '../../containers/TwoColumn/twoColumn';
import { LeftColumn } from '../../containers/TwoColumn/leftColumn';
import { RightColumn } from '../../containers/TwoColumn/rightColumn';
import { FormSectionHeading } from 'src/components/common/texts/FormSectionHeading/formSectionHeading';
import { AddScreenshots } from './AddScreenshots/addScreenshots';
import ZoomGameMockUp from '../../ZoomGameMockUp/zoomGameMockUp';

export const SetScreenshotsAndVideo = () => {
	const { values } = useFormikContext();
	const { t } = useTranslation();

	return (
		<TwoColumn>
			<LeftColumn>
				<FormSectionHeading label={t('form.steps.setScreenshots.label')}>
					{t('form.steps.setScreenshots.heading')}
				</FormSectionHeading>
				<Box mt="-40px">
					<InputField
						label={'Promo video'}
						name="video"
						placeholder="Video"
						leftText="Youtube URL"
					/>

					<AddScreenshots name="screenshots" />
				</Box>
			</LeftColumn>
			<RightColumn>
				<ZoomGameMockUp
					ctaColor={(values as any).colors.actionColor}
					textColor={(values as any).colors.textColor}
					bgColor={(values as any).colors.backgroundColor}
					zoom={{ x: 0, y: 120, width: 400, height: Number('370') }}
					video={(values as any).video}
					screenshots={(values as any).screenshots}
					name={(values as any).name}
				/>
			</RightColumn>
		</TwoColumn>
	);
};
